import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'

import LeaseFinanceForm from './LeaseFinanceForm'
import CashPurchaseForm from './CashPurchaseForm'
import Terms from './Terms'

import { Creators as actions } from '../../redux/actions';
import {
    getIsCashSelected,
    getIsLeaseSelected,
    getIsFinanceSelected,
    getFinanceOptions,
    getMetaFinancePlans,
    getHasTaxesIncluded,
    getPaymentOptions,
    getSelectedTab,
} from '../../redux/selectors';

import { t, l } from 'react-i18nify';

const Calculator = ({purchaseMethodOrder, hideFinancingOption}) => {
    const dispatch = useDispatch();
    const selectedTab = useSelector(getSelectedTab);
    const paymentOptions = useSelector(getPaymentOptions);
    const isCashPurchaseSelected = useSelector(getIsCashSelected);
    const isLeaseSelected = useSelector(getIsLeaseSelected);
    const isFinanceSelected = useSelector(getIsFinanceSelected);
    const financeOptions = useSelector(getFinanceOptions);
    const selectPlan = index => dispatch(actions.selectPlan(index));
    const selectCashPlan = () => dispatch(actions.selectCashPlan());
    const selectTab = tab => dispatch(actions.updateSelectedTab(tab));

    const { vehicleCondition } = paymentOptions || {};

    const purchaseMethodOrderArray = purchaseMethodOrder ? purchaseMethodOrder.split(",") : ['cash', 'finance', 'lease'];

    const [financeIndex, setFinanceIndex] = useState(-1);
    const [leaseIndex, setLeaseIndex] = useState(-1);
    const [isFinanceAvailable, setIsFinanceAvailable] = useState(false);
    const [isLeaseAvailable, setIsLeaseAvailable] = useState(false);
    const [cashOrder, setCashOrder] = useState();
    const [financeOrder, setFinanceOrder] = useState();
    const [leaseOrder, setLeaseOrder] = useState();

    const financingHidden = hideFinancingOption === 'true';

    useEffect(() => {
        setFinanceIndex(financeOptions.findIndex(financeOption => financeOption.purchaseMethod === 'finance'));
        setLeaseIndex(financeOptions.findIndex(financeOption => financeOption.purchaseMethod === 'lease'));
    }, [financeOptions])

    useEffect(() => {
        setIsFinanceAvailable(financeIndex >= 0 ? financeOptions[financeIndex].isAvailable : false);
        setIsLeaseAvailable(leaseIndex >= 0 ? financeOptions[leaseIndex].isAvailable : false);
    }, [financeIndex, leaseIndex]);

    useEffect(() => {
        purchaseMethodOrderArray.forEach((item, index) => {
            if (item === 'cash') setCashOrder(index);
            if (item === 'finance') isFinanceAvailable ? setFinanceOrder(index) : setFinanceOrder(index + 3);
            if (item === 'lease') isLeaseAvailable ? setLeaseOrder(index) : setLeaseOrder(index + 3);
        })
    }, [isFinanceAvailable, isLeaseAvailable])

    useEffect(() => {
        const lowest = Math.min(cashOrder, financeOrder, leaseOrder);

        if (lowest === cashOrder || financingHidden) {
            selectTab('cash')
            selectCashPlan();
        }
        if (lowest === financeOrder && !financingHidden) {
            selectTab('finance')
            selectPlan(financeIndex)
        }
        if (lowest === leaseOrder && !financingHidden) {
            selectTab('lease')
            selectPlan(leaseIndex)
        }
    }, [cashOrder, financeOrder, leaseOrder]);

    const clickTab = item => {
        if (item === 'cash') selectCashPlan();
        if (item === 'finance') isFinanceAvailable && selectPlan(financeIndex);
        if (item === 'lease') isLeaseAvailable && selectPlan(leaseIndex);

        selectTab(item)
    }

    const Tabs = () => {
        return (
            <nav className="tabs vehicle-payment-tabs__title-wrapper">
                <div className={`tabs-title vehicle-payment-tabs__title ${selectedTab === 'cash' ? 'is-active' : ''} ${financingHidden ? 'two-columns' : ''}`} data-theme-style="vehiclePaymentTabs_item_fontColor" style={{order: cashOrder}}>
                    <a role="button" onClick={() => clickTab('cash')} className="tabs-title__anchor" >
                        {t('purchaseMethod.cash')}
                    </a>
                </div>
                {!financingHidden &&
                    <div
                        className={`tabs-title vehicle-payment-tabs__title ${selectedTab === 'finance' ? 'is-active' : ''}`}
                        data-theme-style="vehiclePaymentTabs_item_fontColor" style={{order: financeOrder}}>
                        <a role="button" onClick={() => clickTab('finance')} className="tabs-title__anchor">
                            {t('purchaseMethod.finance')}
                        </a>
                    </div>
                }
                <div className={`tabs-title vehicle-payment-tabs__title ${selectedTab === 'lease' ? 'is-active' : ''} ${financingHidden ? 'two-columns' : ''}`} data-theme-style="vehiclePaymentTabs_item_fontColor" style={{order: leaseOrder}}>
                    <a role="button" onClick={() => clickTab('lease')} className="tabs-title__anchor" >
                        {t('purchaseMethod.lease')}
                    </a>
                </div>
            </nav>
        )
    };

    const notAvailable = () => {
        const notAvailableText = selectedTab === 'finance' ? (
            vehicleCondition.includes('used') ? t('financeNotAvailableUsed') : t('financeNotAvailable')
        ) : (
            vehicleCondition.includes('used') ? t('leaseNotAvailableUsed') : t('leaseNotAvailable')
        );

        return (
            <div className="vehicle-payment-option--not-available">
                {notAvailableText}
            </div>
        )
    }

    return (
        <div className="tabs-bravo vehicle-payment-tabs">
            <Tabs />
            <div className="tabs-content vehicle-payment-tabs__content-wrapper">
                { selectedTab === 'cash' && isCashPurchaseSelected && <CashPurchaseForm /> }
                { ((selectedTab === 'lease' && isLeaseSelected) || (selectedTab === 'finance' && isFinanceSelected)) &&
                    <div className="tabs-panel vehicle-payment-tabs__content is-active">
                        <LeaseFinanceForm />
                        <Terms />
                    </div>
                }
                {((selectedTab === 'finance' && !isFinanceSelected) || (selectedTab === 'lease' && !isLeaseSelected)) && notAvailable()}
            </div>
        </div>
    )
};

export default Calculator